"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearItemWiseSalesLedgerCache = clearItemWiseSalesLedgerCache;
exports.downloadExcelItemWiseSalesLedger = downloadExcelItemWiseSalesLedger;
exports.downloadExcelSalesReportWithNotes = downloadExcelSalesReportWithNotes;
exports.getItemWiseSalesLedgerReport = getItemWiseSalesLedgerReport;
exports.getSalesReportWithNotes = getSalesReportWithNotes;
exports.getSalesReportWithNotesGrandTotal = getSalesReportWithNotesGrandTotal;
exports.getStockValueReport = getStockValueReport;
exports.getTotalStockValue = getTotalStockValue;
var _request = _interopRequireDefault(require("@/utils/request"));
function getStockValueReport(params) {
  return _request.default.get('/reports/stock-value', {
    params
  });
}
function getTotalStockValue(params) {
  return _request.default.get('/reports/get-total-stock-value', {
    params
  });
}
function getItemWiseSalesLedgerReport(params) {
  return _request.default.get('/reports/item-wise-sales-ledger-report', {
    params
  });
}
function downloadExcelItemWiseSalesLedger(data) {
  return (0, _request.default)({
    url: '/reports/download-excel-item-wise-sales-ledger',
    method: 'post',
    data,
    responseType: 'blob',
    // The shared axios instance caps requests at 60s (utils/request.ts).
    // XMLHttpRequest.timeout is total duration — not TTFB — so it aborts the
    // download mid-stream for large exports. Disable it for this one call only.
    timeout: 0
  });
}
function clearItemWiseSalesLedgerCache() {
  return (0, _request.default)({
    url: '/reports/clear-item-wise-sales-ledger-cache',
    method: 'post'
  });
}
function getSalesReportWithNotes(params) {
  return _request.default.get('/reports/sales-report-with-notes', {
    params
  });
}
function getSalesReportWithNotesGrandTotal(params) {
  return _request.default.get('/reports/sales-report-with-notes-grand-total', {
    params
  });
}
function downloadExcelSalesReportWithNotes(data) {
  return (0, _request.default)({
    url: '/reports/download-excel-sales-report-with-notes',
    method: 'post',
    data,
    responseType: 'blob'
  });
}